import React, { useState } from "react";

 const stylesubmit = {
        backgroundColor: "#FFAB2D",
        color: "white",
        fontSize: "24px",
        fontWeight: "bold",
        borderRadius: "5px",
        paddingTop: "10px",
     paddingBottom: "10px",
     border: 0,
        width: "255px"
    }

export default function Problem() {
    const [uName, setUname] = useState()
    const [uPhone, setUphone] = useState()

    const userName = (e) => {
    setUname(e.target.value)
    }
    const userPhone = (e) => {
    setUphone(e.target.value)
}
    const call = () => {
        if(uName && uPhone)
            alert('Спасибо за обращение ' + uName + "! Мы перезвоним вам по номеру " + uPhone)
        else return
    }
    return (
        <>
         <div className='problem'>
            <img id='bank3' src='../images/bank3.png' />
            <p id='problemtitle'>Есть проблема,<br/>
            но не знаете как решить?</p>
            <p id="problemtext">Наши специалисты готовы дать Вам любую, даже самую глубокую, юридическую консультацию совершенно бесплатно.</p>
           
            <form className="form-group required control-label" onSubmit={call}>
                    <div className="container-fluid">
                    <div className="row">
                    <div className="col-sm">
                        <input type="text" id="problemname" placeholder="Имя*" onChange={userName} className="form-control" required></input>
                    </div>
                    <div class="col-sm">
                        <input type="number" id="problemphone" placeholder="Номер телефона*" onChange={userPhone} className="form-control" required></input>
                    </div>
                    </div>
                        <div className="row">
                        <div class="col-sm padl">
                                <input type="submit" value="Оставить заявку" style={stylesubmit} id="sbm" />
                        </div>
                        <div class="col-sm padl">
                            <div id="explain">Нажимая на кнопку "Оставить заявку", я даю свое согласие на обработку персональных данных и принимаю условия соглашения</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        </>
    )
}